import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { DateOfStayActions } from './actions';
import {
  ApplicationState,
  DateOfStaySelectors,
} from '../reducers';
import { DateOfStay } from '../../objects/date-of-stay';
import { Observable } from 'rxjs';
import { BaseActionService } from './base.action.service';

/**
 * DateOfStay action service.
 * Purpose of it is to abstract communication with Store
 */
export interface IDateOfStayActionService {
  getDateOfStay(): Observable<DateOfStay | null>;
  setDateOfStay(dateOfStay: DateOfStay | null): void;
}

@Injectable({
  providedIn: 'root'
})
export class DateOfStayActionService
  extends BaseActionService<ApplicationState>
  implements IDateOfStayActionService {
  protected store: Store<ApplicationState>;


  constructor() {
    const store = inject<Store<ApplicationState>>(Store);

    super(store);

    this.store = store;
  }

  readonly dateOfStay = this.selectSignal(DateOfStaySelectors.selectDateOfStay);

  getDateOfStay(): Observable<DateOfStay | null> {
    return super.get(DateOfStaySelectors.selectDateOfStay);
  }

  setDateOfStay(dateOfStay: DateOfStay | null): void {
    super.load(DateOfStayActions.setDateOfStay({ dateOfStay }));
  }
}
